module.exports = __webpack_public_path__ + "img/153.0d4dff6d.png";